module.exports = __webpack_public_path__ + "media/site/images/contact-slider/contact_slideshow-16-50f13eeca459fcbeb46ef5bbe66bcede.jpg";